import { AppstoreAddOutlined, DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type MyInfoModuleSpecsFragment } from '../../../../api/fragments/MyInfoModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useMyInfoSettingsDrawer } from './MyInfoSettingsDrawer';

export type MyInfoModuleActionsProps = {
    module: MyInfoModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const MyInfoModuleActions = ({ module, permissions }: MyInfoModuleActionsProps) => {
    const { t } = useTranslation(['myInfoModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const addMyInfoSettingsDrawer = useMyInfoSettingsDrawer(module);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('myInfoModuleDetails:mainActionButtons.addSetting'),
            key: 'addSetting',
            icon: <AppstoreAddOutlined />,
            onClick: addMyInfoSettingsDrawer.open,
        },
        hasDeletePermission && {
            label: t('myInfoModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('myInfoModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {addMyInfoSettingsDrawer.render()}
        </>
    );
};

export default MyInfoModuleActions;
